var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "50%",
    cy: "17.266846%",
    r: "64.009264%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc13c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m0 40c0-22.0916045 17.9083955-40 40-40s40 17.9083955 40 40c0 22.0911352-17.9083955 40-40 40s-40-17.9088648-40-40"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    height: "107.5%",
    width: "107.5%",
    x: "-3.8%",
    y: "-3.8%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0.952941176   0 0 0 0 0.529411765   0 0 0 0 0.0431372549  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m23.6045802 46.051903c-1.0305504-1.0009855-2.6814961.1060584-2.1479187 1.4392979 2.9555587 7.3846731 10.1750434 12.6012483 18.6156084 12.6012483 8.2993102 0 15.4183679-5.0438782 18.46356-12.2333286.5556338-1.3111831-1.1084518-2.4468535-2.1310244-1.4552537-5.8538646 5.6755362-18.2814773 13.7519358-32.8002253-.3519639"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    height: "127.7%",
    width: "110.7%",
    x: "-5.4%",
    y: "-13.9%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m28.2106152 32.8415224c0 2.743911-1.3196302 4.9678539-2.9471115 4.9678539-1.6279506 0-2.9475809-2.2239429-2.9475809-4.9678539 0-2.7439111 1.3196303-4.967854 2.9475809-4.967854 1.6274813 0 2.9471115 2.2239429 2.9471115 4.967854"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    height: "140.3%",
    width: "167.9%",
    x: "-33.9%",
    y: "-20.1%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "m57.6836079 32.8415224c0 2.743911-1.3196302 4.9678539-2.9471116 4.9678539-1.6279506 0-2.9475808-2.2239429-2.9475808-4.9678539 0-2.7439111 1.3196302-4.967854 2.9475808-4.967854 1.6274814 0 2.9471116 2.2239429 2.9471116 4.967854"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    height: "140.3%",
    width: "167.9%",
    x: "-33.9%",
    y: "-20.1%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "evenodd",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 105.75754)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a36407",
    fillRule: "evenodd",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#e)",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#a36407",
    fillRule: "evenodd",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#g)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#a36407",
    fillRule: "evenodd",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#i)",
    xlinkHref: "#h"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley1);
export default __webpack_public_path__ + "static/media/smiley-1.4963650a25a8f881d4ee8fac20711ab3.svg";
export { ForwardRef as ReactComponent };